"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'modal.settings.title': '聊天设置',
};
